.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.is-loading {
    .sub-wrapper {
      display: none;
    }

    gz-progress-spinner {
      display: block;
    }
  }

  gz-banner {
    display: flex;
    padding-top: 30px;
    padding-left: 36px;
  }

  .customer-wrapper {
    max-width: 950px;
  }

  .sub-wrapper {
    padding: 0;
  }

  gz-progress-spinner {
    display: none;
  }
}

#create-text {
  text-align: left;
  width: 600px;
  margin-bottom: 24px;
}

#console-text {
  text-align: left;
  width: 500px;
  margin-bottom: 24px;
}

#expired-tooltip {
  width: 500px;
  height: auto;
  margin-top: 24px;

  border: 1px solid var(--orange-layout-050-warning);
  border-radius: 4px;

  display: flex;
  align-items: center;

  .icon {
    margin: 12px 16px;
    height: 24px;
    width: 24px;

    color: var(--orange-layout-050-warning);
    font-size: 22px;
  }

  #expired-tooltip-text {
    font-size: var(--body-size);
    padding-right: 16px;
    color: var(--body-text-arrows-400);
  }
}
